import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=44abce88&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=44abce88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44abce88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44abce88')) {
      api.createRecord('44abce88', component.options)
    } else {
      api.reload('44abce88', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=44abce88&scoped=true&", function () {
      api.rerender('44abce88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarPlugin/SideBar.vue"
export default component.exports